/**
 * Created by daniel on 23/04/17.
 */

export const CONFIG_SET_CONTENT_DEFINITIONS = "CONFIG_SET_CONTENT_DEFINITIONS";
export const CONFIG_RESET_CONTENT_DEFINITIONS = "CONFIG_RESET_CONTENT_DEFINITIONS";

export function configSetContentDefinitions(contentDefinitions) {
  return {
    type: CONFIG_SET_CONTENT_DEFINITIONS,
    contentDefinitions,
  }
}

export function configResetContentDefinitions() {
  return {
    type: CONFIG_RESET_CONTENT_DEFINITIONS,
  }
}



// WEBPACK FOOTER //
// ./src/App/Editor/state/config/actions.js